import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const ExampleForm = () => {
  const headerData = [
    { label: 'CR/Project Name', value: 'Project Test' },
    { label: 'Environment', value: 'Production' },
    { label: 'Validity Period', value: '180 days' },
  ];

  const itemsData = [
    {
      category: 'Postpaid',
      items: [
        { name: 'MSISDN', storeId: 'BCC10000KUL', materialCode: '-', quantity: '10' },
        { name: 'Blank Sim', storeId: 'SWK50034', materialCode: '20009721', quantity: '15' },
        { name: 'eSIM', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'VOBB', storeId: '-', materialCode: '-', quantity: '-' },
      ],
    },
    {
      category: 'Prepaid',
      items: [
        { name: 'MSISDN', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'Blank Sim', storeId: '-', materialCode: '-', quantity: '-' },
      ],
    },
    {
      category: 'Starter Pack',
      items: [
        { name: 'RM5', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM10', storeId: 'BCC10000KUL', materialCode: '20013188', quantity: '10' },
        { name: 'RM30', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'Celcom XPAX', storeId: 'BCC10000KUL', materialCode: '20013225', quantity: '3' },
        { name: 'Dynamite - CelcomDigi Prepaid 5G Biru Plan', storeId: 'BCC10000KUL', materialCode: '20015622', quantity: '7' },
        { name: 'Others', storeId: '-', materialCode: '-', quantity: '-' },
      ],
    },
    {
      category: 'Reload',
      items: [
        { name: 'RM5', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM10', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM30', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM50', storeId: '-', materialCode: '-', quantity: '-' },
      ],
    },
    {
      category: 'Softpin',
      items: [
        { name: 'RM5', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM10', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM20', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM30', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM50', storeId: '-', materialCode: '-', quantity: '-' },
        { name: 'RM100', storeId: '-', materialCode: '-', quantity: '-' },
      ],
    }

  ];

  const detials = [
    { label: 'Store ID reference', value: ' ' },
  ]

  const refSIMC = [
    {
        category: 'Production',
        items: [
          { store: 'BlueCube', storeId: 'CKL89999' },
          { store: 'Dealer', storeId: 'CKL89998' },
          { store: 'Enterprise', storeId: '99974' },
        ],
      },
      {
        category: 'Testbed',
        items: [
          { store: 'BlueCube', storeId: 'BCC10000KUL' },
          { store: 'Dealer', storeId: 'SWK50034' },
          { store: 'Enterprise', storeId: '99974' },
        ],
      },
  ];

  const detials2 = [
    { label: 'Material Code reference', value: ' ' },
  ]

  const device = [
    {
        category: 'Blank Sim',
        items: [
          { materialCode: '20012802', description: 'SIM CARD-UNIVERSAL 5G-GHUDC-HALF SIZE', servicetype: 'POSTPAID/PREPAID' },
          { materialCode: '20015621', description: 'SIM CARD-UNIVERSAL-BLANK SIM-64K 3IN1', servicetype: 'POSTPAID/PREPAID' },
          { materialCode: '20009721', description: 'SIM CARD-POSTPAID-GHUDC-64K USIM 3 IN 1', servicetype: 'POSTPAID' },
          { materialCode: '20012352', description: 'SIM CARD-UNIVERSAL-GHUDC-HALF SIZE', servicetype: 'POSTPAID/PREPAID' },
          { materialCode: '20015387', description: 'SIM CARD-GENERIC-LIGHTNING-64K 3IN1', servicetype: 'PREPAID' },
        ],
      },
      {
        category: 'ESIM',
        items: [
            { materialCode: 'ESIM030001', description: 'SIM CARD-ESIM POST-GHUDC-64K ESIM', servicetype: 'POSTPAID' },
        ],
      },
      {
        category: 'Starterpack',
        items: [
          { materialCode: '20015520', description: 'SPACK-CD PREPAID RM5-5G-BIRU', servicetype: 'PREPAID' },
          { materialCode: '20015622', description: 'SPACK-CD PREPAID RM10 MODENTRADE-5G-BIRU', servicetype: 'PREPAID' },
          { materialCode: '20015519', description: 'SPACK-CD PREPAID RM10-5G-BIRU', servicetype: 'PREPAID' },
          { materialCode: '20013225', description: 'SPACK-CXPAX RM5-CTRL1', servicetype: 'PREPAID' },
          { materialCode: '20013188', description: 'SPACK-CXPAX RM10-CTRL1', servicetype: 'PREPAID' },
          { materialCode: '20011545', description: 'SPACK-XPAX2019 RM30-CTRL1', servicetype: 'PREPAID' },
        ],
      }
  ]

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {headerData.map((row) => (
              <TableRow key={row.label}>
                <TableCell component="th" scope="row">{row.label}</TableCell>
                <TableCell colSpan={4}>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} style={{ marginTop: '20px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>Items</TableCell>
              <TableCell>Store ID</TableCell>
              <TableCell>Material Code</TableCell>
              <TableCell>Quantity</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {itemsData.map((category) => (
              <React.Fragment key={category.category}>
                <TableRow>
                  <TableCell rowSpan={category.items.length + 1} component="th" scope="row">
                    {category.category}
                  </TableCell>
                </TableRow>
                {category.items.map((item, index) => (
                  <TableRow key={`${category.category}-${index}`}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.storeId}</TableCell>
                    <TableCell>{item.materialCode}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {detials.map((row) => (
              <TableRow key={row.label}>
                <TableCell component="th" scope="row">{row.label}</TableCell>
                <TableCell colSpan={4}>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Environment</TableCell>
            <TableCell>STORE</TableCell>
            <TableCell>STORE ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {refSIMC.map((category) => (
            <React.Fragment key={category.category}>
              {category.items.map((item, index) => (
                <TableRow key={`${category.category}-${item.store}`}>
                  {index === 0 && (
                    <TableCell rowSpan={category.items.length}>
                      {category.category}
                    </TableCell>
                  )}
                  <TableCell>{item.store}</TableCell>
                  <TableCell>{item.storeId}</TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {detials2.map((row) => (
              <TableRow key={row.label}>
                <TableCell component="th" scope="row">{row.label}</TableCell>
                <TableCell colSpan={4}>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Material Code</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Service Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {device.map((category) => (
            <React.Fragment key={category.category}>
              {category.items.map((item, index) => (
                <TableRow key={`${category.category}-${item.materialCode}`}>
                  {index === 0 && (
                    <TableCell rowSpan={category.items.length}>
                      {category.category}
                    </TableCell>
                  )}
                  <TableCell>{item.materialCode}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell>{item.servicetype}</TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
};

export default ExampleForm;